/** Matches the explicitly requested September 2026 test-data reset. */
const resetMarker = "faheem-collection-reset:20260907-recording-v2";

export function clearPreviousTestCollection(storage: Storage) {
  if (storage.getItem(resetMarker)) return;
  const keys = Array.from({length: storage.length}, (_, index) => storage.key(index));
  for (const key of keys) {
    if (key && (key === "progress-storage" || key.startsWith("faheem-analytics") || key.startsWith("faheem-submission:"))) {
      storage.removeItem(key);
    }
  }
  storage.setItem(resetMarker, "done");
}

// Imported before app stores hydrate. Each tab has its own session storage.
for (const name of ["localStorage", "sessionStorage"] as const) {
  try { clearPreviousTestCollection(window[name]); } catch { /* Storage may be unavailable. */ }
}
